import { Logger } from '../logging/Logger';
import { agentTransferToModel, inboundCampTransferToModel, numberTransferToModel } from "../mappers/models.mapper";
import { triggerNotifications } from "../Helpers/helperMessages";
import { BLOCKED_SETTING_TRANSFER } from '../constants/constants';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from '../constants/Notifications';

export const getSvrXferOptions = (that) => {

    if (that.sharedData.getGeneralPermissions()[BLOCKED_SETTING_TRANSFER.ALL] === "0") {
        triggerNotifications(that, MESSAGE_CODE.BLIND_TRANSFER[10400], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        return;
    }
    let _that = that;
    let objectResponseTransfer = that.apiCont.getObjectResponse();
    let userId = that.sharedData.getParameters().UserID;
    that.apiCont.transferCall(userId, 0, objectResponseTransfer);
    objectResponseTransfer.onError = function (messageError) {
        Logger.Error('[SDK-Kolob][WorkSpace][TransferCall] Error consulting DataBase ', messageError);
    };
    objectResponseTransfer.onSuccess = function (objResponse) {
        let inboundCampTransfersList = [];
        let telephoneList = [];
        let agentTransferList = [];
        if(objResponse.AcdList){
            inboundCampTransfersList = Object.values(objResponse.AcdList).map(inboundCamp => new inboundCampTransferToModel(inboundCamp));
        }else{
            console.warn('Agent doesnt have permission to transfer inbound camp');
        }
        
        if(objResponse.TelefonosList){
            telephoneList = Object.values(objResponse.TelefonosList).map(number => new numberTransferToModel(number));
        }else{
            console.warn('Agent doesnt have permission to transfer numbers');
        }
        if( objResponse.AgentesList){
            agentTransferList = Object.values( objResponse.AgentesList).map(agent => new agentTransferToModel(agent));
        }else{
            console.warn('Agent doesnt have permission to transfer agents');
        }
        _that.svrEvents.onReceivedXferOptions(inboundCampTransfersList, telephoneList, agentTransferList);
    };
}
